import React from "react";
import { getGanttLayout, getGanttZoomConfig } from "./GanttConfig";
import Gantt from "../../../../../lib/Gantt/Dhtmlx/components/Gantt";
import { renderStopPopup } from "./GanttHelper";
import { getTotalDwellTime, getTotalStopTime } from "../util";
import { utcToZonedTime } from "date-fns-tz";
import constants from "./constants";
class DispatchGantt extends React.Component {
  constructor(props) {
    super(props);
  }

  onGanttReady = (gantt) => {
    this.gantt = gantt;
  };

  onBeforeDataRender = () => {
    if (this.props.isRealtimeReport) {
      const { gantt } = this;
      if (gantt) {
        const currentTasks = gantt
          ?.getTaskByTime()
          ?.filter((task) => task.isCurrentStop);
        gantt.batchUpdate(() => this.updateAllCurrentTasks(currentTasks));
      }
    }
  };

  getCurrentTime = () => {
    return utcToZonedTime(new Date(), this.props.terminalOffset);
  };

  updateAllCurrentTasks = (currentTasksList) => {
    currentTasksList.forEach((task) => {
      const currentDateTime = this.getCurrentTime();
      const currentDateTimeStr =
        gantt.date.date_to_str(constants.GANTT_DATE_TIME_FORMAT)(currentDateTime);
      const actualArrivalTime = task.data.actualArrivalTime;
      if (currentDateTime > task.end_date) {
        const currentStopDuration = getTotalStopTime(
          actualArrivalTime,
          currentDateTimeStr
        );
        task.progress = getTotalDwellTime(
          task.stopDuration,
          currentStopDuration
        );
        task.end_date = currentDateTime;
        task.currentDateTime = currentDateTimeStr;
        task.departureTime = gantt.date.date_to_str(constants.GANTT_TIME_FORMAT)(currentDateTime);
        this.gantt.updateTask(task.id);
      }
    });
  };

  render() {
    return (
      <Gantt
        ganttLayout={getGanttLayout()}
        renderStopPopup={renderStopPopup}
        zoomLevels={getGanttZoomConfig()}
        onGanttReady={this.onGanttReady}
        onBeforeDataRender={this.onBeforeDataRender}
        {...this.props}
      ></Gantt>
    );
  }
}

export default DispatchGantt;
